import * as BIManager from './bi';

export const initDealer = ({
  editorSessionId,
  siteId,
  metaSiteId,
  dealerCmsTranslationsUrl,
  lang,
  dealerLightboxUrl,
}: {
  editorSessionId: string;
  siteId: string;
  metaSiteId: string;
  dealerCmsTranslationsUrl: string;
  lang?: string;
  dealerLightboxUrl: string;
}) => {
  if (!window.wixDealerLightbox) {
    return;
  }
  return new window.wixDealerLightbox.DealerLightboxApi().initLightbox({
    location: 'TEMPLATE_VIEWER',
    translationsUrl: dealerCmsTranslationsUrl,
    locale: lang,
    viewerUrl: dealerLightboxUrl,
    onClick: () => BIManager.reportEditorClick({ origin: 'dealerApi' }),
    dealerOptions: {
      editorSessionId,
      siteId,
      metaSiteId,
    },
  });
};
